module.exports = __webpack_public_path__ + "11a5522473ac4a3bd8194e28f82985f9.png";